import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {Component, ElementRef, Input, NgZone, OnDestroy, AfterViewInit} from "@angular/core";
import {animate, sequence, state, style, transition, trigger} from "@angular/animations";
import {fromEvent, Subscription} from "rxjs";

declare var window: any;

@ComponentAsElement('v-button-element')
@Component({
  selector: 'v-button',
  templateUrl: './button.component.html',
  styleUrls: [],
  animations: [
    trigger('triggerClickButton', [
      state('initial', style({transform: 'translateX(0)'})),
      transition('*  => animating', [
        style({transform: 'translateX(-100%)'}),
        sequence([
          animate('0.25s 1.25s ease-in' ,style({
            transform: 'translateX(0)'
          }))]
        )]
      )
    ])
  ]
})


export class ButtonComponent implements AfterViewInit, OnDestroy {

  public stateClick: string;
  private _animatedStartSubscription: Subscription;
  @Input('classes') classes: string;
  @Input('text') text: string;
  @Input('callback') callback: string;
  @Input('translate') translate: boolean = false;
  @Input('animatedtext') animatedText: string;
  @Input('animatedicon') animatedIcon: string;
  @Input('animatedevent') animatedEvent: string;
  @Input('disabled') disabled = false;
  @Input('processing') processing = false;

  constructor(
    private _zone: NgZone,
    private _elementRef: ElementRef
  ) {  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.animatedEvent) {
        this._animatedStartSubscription = fromEvent(this._elementRef.nativeElement, this.animatedEvent).subscribe(e => this.runAnimation(e));
      }
    });
  }

  ngOnDestroy() {
    if (this._animatedStartSubscription) {
      this._animatedStartSubscription.unsubscribe();
    }
  }

  public runAnimation(e) {
    if (this.animatedEvent) {
      //check if success
      if(e === undefined || (e.detail && e.detail.code == 'success')) {
        this.stateClick = "animating";
      }
    }
  }

  public execCallback() {
    this._zone.runOutsideAngular(
      () => {
        const func = window[this.callback];
        if (typeof func === 'function') {
          func();
        } else if (func !== undefined) {
          console.warn(this.callback, 'is not a function on the window object!')
          console.log(window)
        } else {
          console.log('Button', this.text, 'callback not defined, ignoring.')
        }
      }
    );
  }

  public onAnimationDoneEvent(event: AnimationEvent) {
    this.stateClick = "initial";
  }


}
